import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Divider from '@material-ui/core/Divider';

import LinearProgress from '~/components/LinearProgress';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import Button from '~/components/Button';

import AttendantWebSocket from '~/contexts/AttendantWebSocket';
import Request from '~/providers/Request';
import toInt from '~/utils/Number/toInt';
import { editChat, createChat } from '~/config/routes';
import { URL } from '~/config/uri';

function ChatList({ history }) {
  const { t } = useTranslation();
  const { attendant, webSocket } = useContext(AttendantWebSocket);

  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const [chatList, setChatList] = useState([]);

  const handleChat = async (row) => {
    history.push(editChat.reverse({ id: row.id }));
  };

  const fetchChats = async () => {
    setLoading(true);
    const response = await Request.get(
      '/admin/chats/open',
      { qs: search },
      { normalizeJSON: false }
    );
    setLoading(false);
    setChatList(response.data);
  };

  useEffect(() => {
    if (attendant && webSocket) {
      webSocket.on('message', async ({ type }) => {
        if (type === 'chatNewMessage') {
          fetchChats();
        }
      });
    }
  }, [attendant, webSocket]);

  useEffect(() => {
    fetchChats();
  }, [search]);

  return (
    <GridContainer justify="space-between">
      <GridItem xs={12} sm={9} md={9} lg={9} xl={9}>
        <TextField
          label="Buscar"
          variant="outlined"
          onChange={(event) => setSearch(event.target.value)}
          fullWidth
        />
      </GridItem>

      <GridItem>
        <Link style={{ textDecoration: 'none' }} to={createChat.spec}>
          <Button color="green">{t('action.new')}</Button>
        </Link>
      </GridItem>

      <LinearProgress loading={loading} />

      <GridItem xs={12} sm={12} md={9} lg={9} xl={9}>
        <List>
          {chatList.map((row) => {
            return (
              <div key={row.id}>
                <ListItem button onClick={() => handleChat(row)}>
                  <ListItemIcon>
                    <Avatar
                      src={`${URL}/public/user_face/${row?.uuid}.jpg?size=140`}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={row?.name}
                    secondary={`${t('chats.attributes.subject')}: ${
                      row?.subject
                    }`}
                  ></ListItemText>
                  {toInt(row.not_readed) > 0 && (
                    <Badge badgeContent={row?.not_readed} color="primary" />
                  )}
                </ListItem>
                <Divider />
              </div>
            );
          })}
        </List>
      </GridItem>

      <LinearProgress loading={loading} />
    </GridContainer>
  );
}

export default React.memo(withRouter(ChatList));
